export default __webpack_public_path__ + "static/media/bg_pop.3c1fe3f6.svg";